import { render, staticRenderFns } from "./AppSettings.html?vue&type=template&id=1a4ac6fe&scoped=true&external"
import script from "./AppSettings.js?vue&type=script&lang=js&external"
export * from "./AppSettings.js?vue&type=script&lang=js&external"
import style0 from "./AppSettings.vue?vue&type=style&index=0&id=1a4ac6fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4ac6fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import VCard from '@/agilis/wrappers/VCard/VCard.vue'
import { VCardText } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import VTabs from '@/agilis/wrappers/VTabs/VTabs.vue'
installComponents(component, {VCard,VCardText,VTab,VTabItem,VTabs})
